import OrganizationDirectory from 'views/Sales/OrganizationDirectory'

export default function OrganizationDirectoryModal() {
    return (
        <>
            <div className="text-center text-lg font-semibold leading-6 text-gray-900 pb-4">
                Organization Directory
            </div>

            <OrganizationDirectory embeddedInModal={true} />
        </>
    )
}
